<template>
  <modal
    v-if="isModalOpen"
    :disabled="false"
    :modal-open="isModalOpen"
    :toggle-modal="closeModal"
    :modal-heading="modalHeading"
    :modal-heading-title="counselorName"
    class-name="video-modal"
  >
    <div class="video-modal__content">
      <div class="video-modal__player">
        <video
          v-if="hasVideoSources"
          ref="videoPlayer"
          controls
          controlslist="nodownload noremoteplayback nofullscreen"
          preload="metadata"
          :poster="video?.video_thumbed || ''"
          @loadeddata="onVideoLoaded"
          @error="onVideoError"
        >
          <source
            v-if="video?.browser720_h264_encoded"
            :src="video.browser720_h264_encoded"
            type="video/mp4"
          />
          <source
            v-if="video?.video_webm"
            :src="video.video_webm"
            type="video/webm"
          />
          <p>{{ text.videoNotSupported }}</p>
        </video>
        <div v-else class="video-modal__no-video">
          <p>{{ text.noVideoAvailable }}</p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from 'Components/Modal.vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'VideoModal',
  components: {
    Modal,
  },
  data() {
    return {
      text: {
        videoNotSupported: 'Your browser does not support the video tag.',
        noVideoAvailable: 'No video available for this counselor.',
        videoIntroduction: 'Video introduction',
      },
    };
  },

  computed: {
    ...mapState('counselorVideo', ['isModalOpen']),
    ...mapState('user', ['video', 'name']),

    counselorName() {
      return this.name || '';
    },

    hasVideoSources() {
      return !!(
        this.video?.browser720_h264_encoded ||
        this.video?.video_webm ||
        this.video?.original
      );
    },

    modalHeading() {
      return `${this.text.videoIntroduction} - ${this.counselorName}`;
    },
  },

  watch: {
    isModalOpen(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.currentTime = 0;
          }
        });
      } else {
        // Pause video when modal closes
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
        }
      }
    },
  },

  methods: {
    ...mapActions('counselorVideo', ['toggleModal', 'closeModal']),

    onVideoLoaded() {
      // Video metadata loaded successfully
      // Auto-play the video after it's loaded
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.play().catch((error) => {
          console.warn('Auto-play was prevented:', error);
        });
      }
    },

    onVideoError(event) {
      console.error('Video loading error:', event);
    },
  },
};
</script>
